import { motion } from "framer-motion";

/**
 * Skeleton générique pour les états de chargement (premium).
 * Anim subtile via Framer Motion (opacity pulse).
 */
export function Skeleton({ className = "", style = {} }) {
  return (
    <motion.div
      data-testid="skeleton"
      className={`rounded-[8px] ${className}`}
      style={{ background: "#E5E5E5", ...style }}
      animate={{ opacity: [0.45, 0.85, 0.45] }}
      transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
    />
  );
}

export function PostCardSkeleton() {
  return (
    <div
      className="bg-white rounded-[12px] p-6 sm:p-8 mb-4"
      style={{ border: "1px solid #E5E5E5" }}
      data-testid="post-card-skeleton"
    >
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="w-20 h-6" />
        <Skeleton className="w-16 h-6" />
      </div>
      <Skeleton className="w-3/4 h-7 mb-3" />
      <Skeleton className="w-full h-4 mb-2" />
      <Skeleton className="w-5/6 h-4 mb-2" />
      <Skeleton className="w-2/3 h-4 mb-5" />
      <div className="flex items-center gap-3 pt-4 border-t" style={{ borderColor: "#E5E5E5" }}>
        <Skeleton className="w-9 h-9 rounded-full" />
        <div className="flex-1">
          <Skeleton className="w-32 h-4 mb-1" />
          <Skeleton className="w-20 h-3" />
        </div>
      </div>
    </div>
  );
}
